// Converted from application/views/sculptures/la-vespa_v.php. Edit this component directly.
export default function SculpturesLaVespaPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/la-vespa/la-vespa-full.jpg"} alt={"La Vespa"} />
<figcaption>{"#1"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"La Vespa"}</h1>
<p>
<b>{"25 x 60 x 59 cm"}</b><br />{"\n                    9.85” x 23.6” x 23.2”"}<br />{"\n                    Bronze"}<br />{"\n                    No. in Series 10\n                "}</p>
</div>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                One rain-lashed morning, when my model Gea arrived at my studio in Via Luna, she asked me if she could park her Vespa inside.\n            "}</p>
<p>{"\n                “Certainly” I replied, “on one condition.”\n            "}</p>
<p>{"\n                So it was that “La Vespa” came about, with Gea seated in her long dress, hand on knee, bringing on the admiring glances.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/la-vespa/la-vespa-full2.jpg"} alt={"La Vespa"} />
<figcaption>{"#2"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/la-vespa/la-vespa-front.jpg"} alt={"La Vespa front"} />
<figcaption>{"#3"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                There’s something about a woman on a Vespa which excites, but which also sends out a “Take Care!” message!\n            "}</p>
<p>{"\n                Never be too sure which carries the sting!\n            "}</p>
<p>{"\n                Stai attento!  Arriva La Vespa!\n            "}</p>
</div>
</div>
</div>
</>;
}
